import axios from "axios";
import $cookie from "vue-cookie";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return error; // TODO custom errors
  },
);

instance.interceptors.request.use((config) => {
  const token = $cookie.get("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
